import React, { useEffect } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/LandingPage/Footer/Footer";
import cookiePolicyData from "./cookiesData";
import CommonLayout from "../CommonLayout/CommonLayout";

const CookiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main>
      <Navbar />
      <CommonLayout data={cookiePolicyData} /> {/* Layout to display the policies */}
      <Footer />
    </main>
  );
};

export default CookiesPage;
